export function isValidSiret(siret: string): boolean {
	const parse = parseInt(siret, 10);

	if (siret.length !== 14 || isNaN(parse))
		return false;

	let	somme = 0;
	let	tmp;

	for (let cpt = 0; cpt < siret.length; cpt++) {
		if ((cpt % 2) === 0) {
			tmp = parseInt(siret.charAt(cpt), 10) * 2;
			if (tmp > 9)
				tmp -= 9;
		} else
			tmp = parseInt(siret.charAt(cpt), 10);
		somme += tmp;
	}

	return (somme % 10) === 0;
}

export function isValidSiren(siren: string): boolean {
	const parse = parseInt(siren, 10);

	if ((siren.length !== 9) || (isNaN(parse)))
		return false;

	let somme = 0;
	let tmp;

	for (let cpt = 0; cpt < siren.length; cpt++) {
		if ((cpt % 2) === 1) {
			tmp = parseInt(siren.charAt(cpt), 10) * 2;
			if (tmp > 9)
				tmp -= 9;
		} else
			tmp = parseInt(siren.charAt(cpt), 10);
		somme += tmp;
	}

	return (somme % 10) === 0;
}

export function isValidSiretOrSiren(siren: string): boolean {
	return isValidSiret(siren) || isValidSiren(siren);
}

export function ft_fetchPappers(siren: string) {
	if (!isValidSiretOrSiren(siren))
		return 'notValid';

	return (
		fetch(`https://suggestions.pappers.fr/v2/?cibles=siren,siret&q=${siren}`)
		.then(response => response.json())
		.then(json => json)
		.catch(err => err)
	);
}